export const SIZE_LOADING = 40;
